import { Button } from "@/components/ui/button";
import { Link } from "react-router";

export default function NotFound() {
  return (
    <div className="py-32 text-center">
      <div className="max-w-[1120px] mx-auto px-6">
        <div className="text-8xl font-extrabold text-muted-foreground/30 mb-4">404</div>
        <h1 className="text-3xl font-extrabold tracking-tight mb-3">Page not found</h1>
        <p className="text-base text-secondary-foreground max-w-md mx-auto mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-3 justify-center">
          <Button size="lg" asChild>
            <Link to="/">Go Home</Link>
          </Button>
          <Button variant="outline" size="lg" asChild>
            <Link to="/docs">View API Docs</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
